/**
 * Determines environment from window.location before Angular bootstrap.
 * This utility is used in main.ts before Angular bootstraps.
 *
 * Note: All environments (except localhost) must have .paramountmsc.com in the hostname.
 */
export function getEnvironmentFromLocation() {
    const hostname = window.location.hostname;
    const href = window.location.href;
    const hasMscOrVicomDomain = hostname.includes('.paramountmsc.com') || hostname.includes('contentplatform.viacom.com');
    // Check for localhost first (always dev, no domain required)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'dev';
    }
    // Validate: All non-localhost environments must have .paramountmsc.com
    if (!hasMscOrVicomDomain) {
        console.warn('⚠️ Hostname does not contain .paramountmsc.com or contentplatform.viacom.com, defaulting to dev');
        return 'dev';
    }
    // Dev environment: PR or dev- patterns
    if (href.includes('pr.paramountmsc.com') || hostname.includes('dev-') || hostname.includes('dev.')) {
        return 'dev';
    }
    // UAT environment patterns
    if (hostname.includes('uat-') || hostname.includes('uat.')) {
        return 'uat';
    }
    // QA environment patterns
    if (hostname.includes('qa-') || hostname.includes('qa.')) {
        return 'qa';
    }
    // If it has .paramountmsc.com and doesn't match any specific pattern above, it's prod
    return 'prod';
}
//# sourceMappingURL=environment-detector.util.js.map